import { Tooltip } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";
import SmallPieChart from "../charts/small-pie";

interface IProps {
  title?: string;
  subTitle?: string;
  count?: number;
  icon?: React.ReactNode;
  toolTip?: string;
  details?: {
    label: string;
    value: number;
    colorType?: "primary" | "secondary" | "tertiary";
  }[];
  chartData?: { labels: string[]; data: number[]; colors: string[] };
}

const Card: React.FC<IProps> = ({
  title,
  subTitle,
  count,
  icon,
  toolTip,
  details = [],
  chartData,
}) => {
  const { t } = useTranslation();

  const hasChart = chartData && chartData.data.length > 1;

  return (
    <Tooltip
      overlayStyle={{ fontSize: "1rem" }}
      placement="top"
      title={toolTip ? t(toolTip) : ""}
      color="#0d4ea2"
    >
      <div className={styles.cardWrapper}>
        <div className={styles.cardContent}>
          <div className={styles.cardHeader}>
            <div className={styles.iconCircle}>{icon}</div>
            <div className={styles.titleBlock}>
              <div className={styles.titleRow}>
                <h3 className={styles.title}>{title && t(title)}</h3>
                {count !== undefined && (
                  <span className={styles.mainCount}>{count}</span>
                )}
              </div>
              {subTitle && <span className={styles.subTitle}>{t(subTitle)}</span>}
            </div>
          </div>

          <div className={styles.inlineStatsChart}>
            <div className={styles.inlineStats}>
              {details.map((item, index) => (
                <div className={styles.inlineStatItem} key={index}>
                  <span className={styles.inlineLabel}>{t(item.label)}:</span>
                  <span
                    className={
                      item.colorType === "tertiary"
                        ? styles.inlineValueAlt3
                        : item.colorType === "secondary"
                          ? styles.inlineValueAlt2
                          : styles.inlineValueAlt1
                    }
                  >
                    {item.value}
                  </span>
                </div>
              ))}
            </div>

            {hasChart && (
              <div className={styles.inlineChart}>
                <SmallPieChart data={chartData} />
              </div>
            )}
          </div>
        </div>
      </div>
    </Tooltip>
  );
};

export default Card;
